/* eslint-disable no-unused-vars */
export enum UITextContentWrapperVariants {
  big = 'big',
  small = 'small',
  event = 'event',
  allInclusive = 'allInclusive',
};
